import { Injectable } from "@angular/core";
import { Oui_TypeOuiNonInformComplementaire } from "../../models/Oui_TypeOuiNonInformComplementaire";
import { TypeOuiNonInformComplementaire } from "../../models/TypeOuiNonInformComplementaire";
import { RadioCheckBoxEnum } from "../../../../common/radio.checkbox.enums";

@Injectable({
    providedIn: 'root'
})
export class InformComplementaireService {

    constructor() { }

    getInformComplementaire(controls): TypeOuiNonInformComplementaire {

        const informComplementaire = new TypeOuiNonInformComplementaire();
        informComplementaire.autresInformComplementaire = controls.get('_SepSep_Initial_SepSep_TypeOuiNonInformComplementaire_SepAtt_autresInformComplementaire')

        if(controls.get('_SepSep_Initial_SepSep_TypeOuiNonInformComplementaire_SepAtt_non') === 'Oui') {
            informComplementaire.oui = new Oui_TypeOuiNonInformComplementaire();
            informComplementaire.oui.visiteDetail = controls.get('_SepSep_Initial_SepSep_TypeOuiNonInformComplementaire_SepSep_Oui_TypeOuiNonInformComplementaire_SepAtt_visiteDetail');
            informComplementaire.non = null;
        } else if(controls.get('_SepSep_Initial_SepSep_TypeOuiNonInformComplementaire_SepAtt_non') === 'Non'){
            informComplementaire.oui = null;
            informComplementaire.non = RadioCheckBoxEnum.emptyValue;
        }else{
          informComplementaire.oui = null;
          informComplementaire.non = null;
        }
        return informComplementaire;
    }
}
